<footer class="footer ">
  <div class="container-fluid">
    <nav class="pull-left">
      <ul class="menu-underline" data-animation="center">
        <li>
          <a class="hand-cursor"
             [ngClass]="{'active-lang': selectedLanguage == 'es'}"
             style="padding:0px; margin: 4px 8px;" (click)="changeLanguage('es')">
            {{'language.es' | translate}}
          </a>
        </li>
        <li>
          <a class="hand-cursor"
              [ngClass]="{'active-lang': selectedLanguage == 'en'}"
             style="padding: 0px; margin: 4px 8px;" (click)="changeLanguage('en')">
            {{'language.en' | translate}}
          </a>
        </li>
      </ul>
    </nav>
    <!--<div class="copyright pull-right">
      &copy;
      {{test | date: 'yyyy'}}, made with <i class="material-icons">favorite</i> by
      <a href="https://www.creative-tim.com" target="_blank">Creative Tim</a> for a better web.
    </div>-->
  </div>
</footer>
